// extracted by mini-css-extract-plugin
module.exports = {"consent":"consent-24Kkh4X","checkbox":"checkbox-2GqQRm4","link":"link-2ybb9fr"};